module.exports = __webpack_public_path__ + "static/media/round-button-secondary.555b0f77.svg";